import * as React from 'react'
import PropTypes from 'prop-types'

import {
  Wysiwyg,
  TextWrapper,
  Container,
  TextContainer,
  ButtonWrapper
} from './style'

const ArticleBlockText = ({
  text1 = '',
  text2 = '',
  action = null
}) => {
  return (
    <Container>
      <TextContainer>
        <TextWrapper>
          <Wysiwyg className={ text2 && 'halfBlock' } html={ text1 } alt />

          {text2 && (
            <Wysiwyg className='halfBlock' html={ text2 } alt />
          )}
        </TextWrapper>
        <ButtonWrapper>
          {
            !!action && (
              action
            )
          }
        </ButtonWrapper>
      </TextContainer>
    </Container>
  )
}

ArticleBlockText.propTypes = {
  text1: PropTypes.string,
  text2: PropTypes.string,
  action: PropTypes.any
}

export default ArticleBlockText
